import PropTypes from 'prop-types';
import clsx from 'clsx';

const badgeColors = {
  blue: 'bg-blue-500 text-white',
  green: 'bg-green-500 text-white',
  red: 'bg-red-500 text-white',
  yellow: 'bg-yellow-400 text-black',
  gray: 'bg-gray-300 text-gray-800',
};

export const Badge = ({ color = 'gray', children, size = 'md' }) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-semibold',
        badgeColors[color],
        sizeClasses[size]
      )}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  color: PropTypes.oneOf(['blue', 'green', 'red', 'yellow', 'gray']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node.isRequired,
};
